import { createApi } from '@core/fetch'

export default {
  invoiceList: createApi('/p/wedding/admin/APIMerchantInvoice/list'),
  invoiceDetail: createApi('/p/wedding/admin/APIMerchantInvoice/detail'),
  invoiceSave: createApi.post('/p/wedding/admin/APIMerchantInvoice/insert'),
  preSaveInvoice: createApi('/p/wedding/admin/APIMerchantInvoice/addInvoice')
}
